export const AMPLIFY_STORE_PREFIX = '@cucon-cognito-';
